import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Layout as AntLayout, Button } from 'antd';
import { LogoutOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { colors, spacing } from '../theme';

const { Content } = AntLayout;

interface AttendeeLayoutProps {
  children: React.ReactNode;
  showBackButton?: boolean;
  onSignOut: () => void;
  homeRoute?: string;
}

export function AttendeeLayout({
  children,
  showBackButton = false,
  onSignOut,
  homeRoute = '/'
}: AttendeeLayoutProps) {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(homeRoute);
  };

  return (
    <AntLayout style={{ minHeight: '100vh', background: colors.background }}>
      <Content
        style={{
          padding: '24px',
          maxWidth: 800,
          margin: '0 auto',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {children}

        <div style={{ marginTop: 'auto', paddingTop: spacing.lg }}>
          {showBackButton && (
            <Button
              type="default"
              icon={<ArrowLeftOutlined />}
              onClick={handleBack}
              style={{
                width: '100%',
                marginBottom: spacing.sm,
                color: colors.primary,
                borderColor: colors.primary,
              }}
            >
              Voltar para Início
            </Button>
          )}
          <Button
            type="text"
            icon={<LogoutOutlined />}
            onClick={onSignOut}
            style={{
              width: '100%',
              color: colors.textDescription,
            }}
          >
            Sair
          </Button>
        </div>
      </Content>
    </AntLayout>
  );
}

export default AttendeeLayout;
